<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">      
      <div class="pledge-box1"> 
        
        <!-- filter -->
        <div class="pledge-box1-top"> 
          <div class="Quarterly-Report" style="float: left;">
            <div class="head-title" @click.stop="showDateDropmemu($event)">
              {{ datetype_name }}
              <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
            </div>
            <ul class="menu-lanmu" v-show="dateDropmenu">  
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(1)">一个月</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(2)">一个季度</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(3)">半年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(4)">去年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(5)">今年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(6)">一年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(7)">两年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(8)">三年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(9)">五年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(10)">十年</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(98)">全部</a></li>
              <li><a href="javascript:;" @click="clickDropmenu(), changeDateType(99)">自定义</a></li>
            </ul>
          </div> 

          <a class="cop-search-bot" href="javascript:;" @click="largeexchangeFilter">查询</a>
          <div class="cop-date" v-if="datetype == 99">
            <p class="time"> 
              <span class="l">
                <date-picker :time.sync="startdate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
              至 
              <span class="r">
                <date-picker :time.sync="enddate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
            </p>
          </div>
        </div><!-- /filter -->

        <!-- main -->
        <div class="pledge-box1" v-if="largeexchangeLists.length>0">
          <div class="Single-list-main">  
            <ul class="Single-list-box" v-for="h in largeexchangeLists" track-by="$index">
              <li><p class="date">交易日期</p><p class="time">{{ h.transaction_date }}</p></li>
              <li><p class="date">成交量(股) </p><p class="time">{{ h.volume | money }}</p></li>
              <li><p class="date">成交额(元)</p><p class="time">{{ h.turnover | money }}</p></li> 
              <li><p class="date">买方营业部</p><p class="time">{{ h.buy_sales_department }}</p></li>   
              <li><p class="date">卖方营业部</p><p class="time">{{ h.sell_sales_department }}</p></li>   
            </ul> 
          </div>    
        </div>
        <div class="cop-pledge-page" v-if="largeexchangeLists.length > 0"> 
          <template v-if="page > 1">
            <span class="Previous-page" @click="page--, getLargeexChangeLists()">上一页</span>
          </template>
          <span class="menu-page"><span style="color: #3270ad">{{ page }}</span>/{{ totalPage }} </span>
          <template v-if="page < totalPage"> 
            <span class="lower-page" @click="page++, getLargeexChangeLists()">下一页</span> 
          </template>
        </div>
        <!-- /main -->

        <div class="Single-list-main" v-if="!largeexchangeLists.length>0 && !loading"> 
          <div class="Block-trade-no">暂无数据</div>
        </div>
        

        <!-- echart 图 -->
        <div v-if="largeexchangeLists.length > 0">
          <h3 class="title">大宗交易趋势图</h3>
          <div class="cop-chart"> 

            <div class="relation-chart" id="dzjy-chart-wrap">
              <div id="dzjy-chart" style="width:100%; height:200px"></div>
            </div>
          </div><!-- /echart 图 -->
        </div>

      </div>
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import myDatepicker from '../../helper/datepicker.vue'
  import echarts from 'echarts'
  import wxshareMix from '../../common/wxshareMix'


  export default {
    name: 'InvestView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    components: {
      'date-picker': myDatepicker,
    },
    data () {
      return {
        largeexchangechart: [],       //大宗交易chart图表数据
        largeexchangechartSored: [],  //排序后的chart图表数据
        tableSort: {
          jyrq: 0, //0未选择，1升序，2降序
          cjl: 0,
          cje: 0,
        },
        largeexchangeLists: [],
        page: 1,
        perPage: 10,
        total: 0,
        totalPage: 0,
        datepicker: {
          option: {
            type: 'day',
            week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            format: 'YYYY-MM-DD',
            placeholder: '',
            inputStyle: {
              'display': 'inline-block',
              'width': '120px',
              'padding': '4px 6px',
              'line-height': '22px',
              'font-size': '16px',
              'box-shadow': '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
              'border-radius': '5px',
              'color': 'rgb(95, 95, 95)'
            },
            color: {
              header: '#00736a',
              headerText: '#ffffff'
            },
            buttons: {
              clear: '清空',
              today: '今天',
              ok: '确定',
              cancel: '取消'
            },
            overlayOpacity: 0.5, // 0.5 as default
            dismissible: true // as true as default
          },
        },
      }
    },
    route: {
      data({to}) {
        
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) {
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;
          this.largeexchangechart = [];
          this.largeexchangechartSored = [];

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.setSelectedTab();
          this.changeDateType(7);
          this.datetype_name = '两年';
          this.tableSort.jyrq = 1;
          this.getLargeexChangeLists();
          this.getLargeexchangeChart();
        }

      }
    },
    methods: {
      // 重绘制大宗交易曲线图
      reDrawChart: function(type) {
        //日期补全
        let newA = [];
        let allDays = [];

        if (type == '非全部') {
          allDays = this.getAllDay(this.startdate, this.enddate);
        } else if (type == '全部') {
          let startdate = this.largeexchangechartSored[0].date;
          let enddate = this.largeexchangechartSored[ this.largeexchangechartSored.length - 1 ].date;
          allDays =  this.getAllDay(startdate, enddate);
        }
        for (let d of allDays) {
          if (this.dzjyOriginObj[d]) {
            newA.push({ date: d, num: this.dzjyOriginObj[d] });
          } else {
            newA.push({ date: d, num: null });
          }
        }

        let dataX = [];
        let dataY = [];
        if (type == '非全部') {
          for (let item of newA) {
            if (item.date >= this.startdate && item.date <= this.enddate) {
              dataX.push(item.date);
              dataY.push(item.num);
            }
          }
          if (dataX[0] != this.startdate) {
            dataX.unshift(this.startdate);
            dataY.unshift(null);
          }
          if (dataX[dataX.length-1] != this.enddate) {
            dataX.push(this.enddate);
            dataY.push(null);
          }
        } else if (type == '全部') {
          for (let item of newA) {
            dataX.push(item.date);
            dataY.push(item.num);
          }
        }

        let that = this;
        setTimeout(function() {
          that.$nextTick(function() {
            that.DzjyChart(dataX, dataY);
          });
        }, 2000);
      },
      /**
       * 大宗交易图谱显示数据
       */
      getChartData: function(datas) {
        if (!datas || datas.length==0) { return; }

        let lists = [];
        for (let ls of datas) {
          lists.push(ls);
        }

        //按日期排序
        lists.sort((a, b) => {
          return Date.parse(a.date) - Date.parse(b.date);
        });

        //根据日期去重，对重复的计算总的交易额
        let tmp = {};
        for (let item of lists) {
          if (!tmp[item.date]) {
            tmp[item.date] = parseFloat(item.turnover);
          } else {
            for (let key in tmp) {
              if (key == item.date) {  //同日期
                tmp[key] = tmp[key] + parseFloat(item.turnover);
                break;
              }
            }
          }
        }
        this.dzjyOriginObj = tmp;

        let newA = [];
        for (let key in tmp) {
          newA.push({date: key, num: tmp[key]});
        }
        this.largeexchangechartSored = newA;

        this.$nextTick(function() {
          this.reDrawChart('非全部');
        });
      },
      //大宗交易echart
      DzjyChart: function(dataX, dataY) {
        //删除画布节点，并创建新的节点。
        if ($('#dzjy-chart')) {
          console.log('nononono');
          $('#dzjy-chart').remove();
          $('#dzjy-chart-wrap').append('<div id="dzjy-chart" style="width:100%;height:200px"></div>')
        }

        //水印
        let img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
        //画布div
        let chart = document.getElementById('dzjy-chart');
        if (!chart) {
          console.log('!!!');
          return false
        }

        // 配置
        var option = {
          title: {
            // text: '大宗交易趋势图',
            text: '',
            x: 'center',      //居中显示，默认显示在左边
            // subtext: '纯属虚构'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            formatter: function(datas) {
              if (!datas[0].value) {
                return;
              } else {
                var res = "<ul><li>" + datas[0].axisValue + '<li/>';
                res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[0].color + "'></span>" + datas[0].seriesName + "：" + datas[0].value.toLocaleString('en-US') + "<li/>";
                res += '</ul>';
                return res;
              }
            }
          },
          // toolbox: {
          //   show: true,
          //   itemGap: 10,  //间隔
          //   right: 20,    //工具栏距右侧距离
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          //直角坐标系内绘图网格
          grid: {
            left: '4%',   //grid 组件离容器左侧的距离。
            right: '4%',
            bottom: '4%',
            top: '15%',
            containLabel: true  //grid 区域是否包含坐标轴的刻度标签。
          },
          xAxis:  {
            type: 'category',
            boundaryGap: false,  // false: 没边距
            data: dataX,
            axisTick: {
              alignWithLabel: true
            }
          },
          yAxis: {
            type : 'value',
            name : '交易总额(元)',  //y轴坐标单位
            // max : 500
            //
            // axisLabel: {
            //   formatter: '{value} W'
            // },
            axisPointer: {
              snap: true
            }
          },
          graphic: [
            {
              type: 'image',
              left: 0,       // left right只能有一个生效
              top: -10,
              z: -10,
              bounding: 'raw',
              origin: [75, 75],
              // repeat: true,
              // repeat: 'repeat',
              style: {
                image: img_shuiyin,
                width: 350,
                height: 180,
                opacity: 0.4
              }
            }
          ],
          series: [
            {
              name:'交易总额(元)',
              type:'line',
              connectNulls: true,
              // smooth: true,
              data: dataY,
            }
          ]
        };
        // 初始化
        let myChart = echarts.init(chart);
        // 绘制
        myChart.setOption(option);
      },
      //大宗交易表格排序
      dzjyTableSort: function(type) {
        let resource = this.largeexchangeLists;

        //交易日期
        this.tableSort.jyrq = 1;
        resource.sort((a, b) => {
          return Date.parse(b.transaction_date) - Date.parse(a.transaction_date);
        });

        this.largeexchangeLists = resource;
      },
      // 分页排序
      dzjyTableSort2: function(type) {
        let resource = this.largeexchangeLists;

        //交易日期
        this.tableSort.jyrq = 1;

        resource.sort((a, b) => {
          return Date.parse(b.transaction_date) - Date.parse(a.transaction_date);
        });

        this.largeexchangeLists = resource;
      },
      //大宗交易筛选
      largeexchangeFilter: function() {
        // 重置一些数据
        this.page = 1;

        let query = {};
        query.code = this.companycode;
        query.page = this.page;
        query.perPage = this.perPage;
        // 重绘制图谱
        if (this.datetype_name != '全部') {
          query.startdate = $.trim(this.startdate);
          query.enddate = $.trim(this.enddate);
          this.reDrawChart('非全部');
        } else {
          this.reDrawChart('全部');
        }
        query.uid = parseInt(this.queryParam.uid);
        query.ruid = parseInt(this.queryParam.ruid);
        query.share = this.queryParam.share;
        query.plat = this.queryParam.plat;
        query.sid = this.queryParam.sid;

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/largeexchange'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.largeexchangeLists = response.lists;
            this.total = response.total;
            this.totalPage = Math.ceil(response.total / this.perPage);

          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })

        // 排序
        this.$nextTick(function() {
          // 按交易日期排序
          this.tableSort.jyrq = 1;
          this.dzjyTableSort('transaction_date');
        });
      },
      // 获取大宗交易列表数据
      getLargeexChangeLists: function() {
        let query = {};
        query.code = this.companycode;
        query.page = this.page;
        query.perPage = this.perPage;
        if (this.datetype_name != '全部') {
          query.startdate = $.trim(this.startdate);
          query.enddate = $.trim(this.enddate);
        }
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/largeexchange'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.largeexchangeLists = response.lists;
            this.total = response.total;
            this.totalPage = Math.ceil(response.total / this.perPage);
            // console.log(this.largeexchangeLists.length);

            // 排序
            let typ = '';
            if (this.tableSort.jyrq === 1 || this.tableSort.jyrq === 2) {
              typ = 'transaction_date';
              if (this.tableSort.jyrq === 1) {
                this.tableSort.jyrq = 2
              } else  if (this.tableSort.jyrq === 2) {
                this.tableSort.jyrq = 1
              }
            } else if (this.tableSort.cjl === 1 || this.tableSort.cjl === 2) {
              typ = 'volume';
              if (this.tableSort.cjl === 1) {
                this.tableSort.cjl = 2
              } else  if (this.tableSort.cjl === 2) {
                this.tableSort.cjl = 1
              }
            } else if (this.tableSort.cje === 1 || this.tableSort.cje === 2) {
              typ = 'turnover';
              if (this.tableSort.cje === 1) {
                this.tableSort.cje = 2
              } else  if (this.tableSort.cje === 2) {
                this.tableSort.cje = 1
              }
            }
            if (typ != '') {
              this.dzjyTableSort2(typ);
            }
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      getLargeexchangeChart: function() {
        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid
        this.loading = true;

        $.ajax({
          url: apiUrl('/V1.0.0/company/largeexchangechart'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({code: this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.largeexchangechart = response.lists;
            this.getChartData(response.lists);
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
  .cop-date .time {
    width: 100%;
    float: left;
  }
</style>


/** WEBPACK FOOTER **
 ** LargeexChange.vue?88826a2a
 **/